export default "__VITE_ASSET__CFHzvftk__"